export const DASH = '—'

export function formatText(value: string | null | undefined): string {
  if (value == null || value === '') return DASH
  return value
}

// CSV form of a cell that formatText showed as a dash: a blank cell, which a
// spreadsheet filters and sums more cleanly than the dash.
export function dashExport(value: unknown): string {
  return value === DASH ? '' : String(value)
}
